<template>
  <div class="modal">
    <div
      class="modal-background"
      @click="
        this.$emit('close');
        scroll();
      "
    ></div>
    <div class="modal-wrapper">
      <div class="modal-header">
        <slot name="header"> </slot>
        <button
          class="close-modal"
          aria-label="close"
          @click="
            this.$emit('close');
            scroll();
          "
        >
          <img
            src="https://2020-uki.s3.eu-west-2.amazonaws.com/video_partners/img/close-icon.svg"
          />
        </button>
      </div>
      <div class="modal-info">
        <!-- Any other Bulma elements you want -->

        <slot name="body"> Default body </slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    scroll() {
      const html = document.querySelector("html");
      html.classList.remove("is-clipped");
    },
  },
};
</script>

<style scoped>
.modal {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
  display: table;
}
.modal-wrapper {
  position: relative;
  margin: 20px;
  width: calc(100% - 40px);
  height: calc(100vh - 40px);
  box-shadow: 0 0 40px rgba(0, 0, 0, 0.8);
}
.modal-header {
  position: absolute;
  z-index: 3;
  top: 0;
  left: 0;
  min-width: 100%;
  display: flex;
  background-color: #fff;
  padding: 15px;
  color: #000;
  height: 50px;
}
.close-modal {
  margin-left: auto;
  border: 0;
  background: transparent;
  cursor: pointer;
}
.close-modal:hover {
  opacity: 0.5;
}
.modal-info {
  width: 100%;
  position: absolute;
  top: 50px;
  right: 0;
  bottom: 0;
  left: 0;
  overflow-y: auto;
  background-color: var(--getty-black);
}
.modal-close {
  position: absolute;
  right: 10px;
  top: 10px;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter-active,
.modal-leave-active {
  transition: opacity 0.5s ease;
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}
</style>